import React from 'react';
import { filterProps } from './props';
export var omitProps = function omitProps(componentFn, _omitProps2) {
  if (_omitProps2 === void 0) {
    _omitProps2 = [];
  }

  return /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
    var _omitProps;

    var restProps = !((_omitProps = _omitProps2) != null && _omitProps.length) ? props : filterProps(props, function (key) {
      return !_omitProps2.includes(key);
    });
    return componentFn(restProps, forwardedRef);
  });
};
export var withOmitProps = function withOmitProps(omitProps) {
  if (omitProps === void 0) {
    omitProps = [];
  }

  return {
    shouldForwardProp: function shouldForwardProp(prop) {
      return !omitProps.includes(prop);
    }
  };
};